function applyClampValue() {
	document.body.querySelectorAll('[data-text-line-cut]').forEach(element => {
		(element as HTMLElement).style.webkitLineClamp = (element as HTMLElement).dataset.textLineCut as string;
	});
}

(() => {
	if(document.readyState !== 'loading') {
		applyClampValue();
	} else {
		document.addEventListener('DOMContentLoaded', applyClampValue);
	}
})();



// WEBPACK FOOTER //
// typescript://../clientlibs/js/bootstrap/textcutter.ts